export const GET_JOBS = "GET_JOBS";
export const GET_JOBS_FAILURE = "GET_JOBS_FAILURE";
export const GET_JOBS_SUCCESS = "GET_JOBS_SUCCESS";

export const GET_JOB = "GET_JOB";
export const GET_JOB_FAILURE = "GET_JOB_FAILURE";
export const GET_JOB_SUCCESS = "GET_JOB_SUCCESS";

export const CREATE_APPLICATION = "CREATE_APPLICATION";
export const CREATE_APPLICATION_FAILURE = "CREATE_APPLICATION_FAILURE";
export const CREATE_APPLICATION_SUCCESS = "CREATE_APPLICATION_SUCCESS";

export const TRACK_APPLICATION = "TRACK_APPLICATION";
export const TRACK_APPLICATION_FAILURE = "TRACK_APPLICATION_FAILURE";
export const TRACK_APPLICATION_SUCCESS = "TRACK_APPLICATION_SUCCESS";

